import PROPS_PLUGIN from"./props/main.js";



export const CORE_PLUGINS=[PROPS_PLUGIN];